import React, { useEffect, useState } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import D from '@assets/themes/dimensions';
import IconButton from '@components/IconButton/index';
import Tooltip from '@components/Tooltip';
import { ArrowLeftIcon } from '@assets/icons/arrowLeftIcon';

const AppBar:React.FC<IProps> = (props) => {

  const handleOpenMenu = () => {
    props.setOpenMenu(!props.openMenu)
  }

  return (
    <S.Root>
      <S.BarContainer height={props.newHeight ? props.newHeight : D.MAIN_APP_BAR_HEIGHT}>
        {
          props.newTitle !== undefined &&
          <S.ArrowIconContainer onClick={() => handleOpenMenu()} >
            <Tooltip
              tip={!props.openMenu ? "Collapse" : "Expand"}
            >
              <IconButton>
              <S.RotateIconInit style={{
                transform: !props.openMenu ? `rotate(0deg)` : `rotate(180deg)`
              }} >
                <ArrowLeftIcon />
              </S.RotateIconInit>
              </IconButton>
            </Tooltip>
          </S.ArrowIconContainer>
        }
        <S.TitleContainer>
          {props.newTitle}
        </S.TitleContainer>
        {props.renderAction && props.renderAction()}
      </S.BarContainer>
    </S.Root>
  );
}

export default AppBar;